import { HttpErrorResponse } from '@angular/common/http';
import { HttpResponseErrorCode, HttpStatusCode } from 'quantuvis-angular-common/api';

export class BidErrorResponseStatusUtil {
  public static isShowErrorInNotification(response: HttpErrorResponse): boolean {
    return response.status !== HttpStatusCode.FORBIDDEN ||
      response.error?.code !== HttpResponseErrorCode.LOCK_VERIFICATION_FAILED;
  }
}
